import React, { Component } from 'react';
import { renderToStaticMarkup } from 'react-dom/server'
import PropTypes from 'prop-types';
import { Form } from 'react-form';
import merge from 'lodash/merge';

import CreditCardForm from 'forms/CreditCardForm';
import TextInput from 'forms/TextInput';
import CheckboxInput from 'forms/CheckboxInput';

import { Elements } from 'react-stripe-elements';

import cardValidator from 'validators/cardValidator';

class Payment extends Component {

  render() {
    const formOptions = {
      onSubmit: values => {
        this.props.createOrder(values)
      },
      validate: cardValidator
    };

    return (
      <Form {...formOptions}>
        {formApi => {
          const inputOptions = {
            formApi,
          };

          return (
            <form className="cart-form" onSubmit={formApi.submitForm} noValidate>
              <h1 className="cart-formTitle">{App.t('cart.payment')}</h1>
              <div className="cart-paymentMessage">
                <p dangerouslySetInnerHTML={{ __html: App.t('cart.payment_text', { link: renderToStaticMarkup(<a href="https://stripe.com" target="_blank">Stripe.com</a>) }) }} />
              </div>

              <TextInput name="cardholder_name" label={App.t('order.cardholder_name')} placeholder={App.t('order.cardholder_name')} {...inputOptions} />

              <Elements>
                <CreditCardForm
                  setStripe={this.props.setStripe}
                  tokenReceived={this.props.tokenReceived}
                  formApi={formApi}
                />
              </Elements>

              <CheckboxInput name="termsAccepted" label={App.t('cart.accept_terms')} className="cart-termsInput" {...inputOptions} />
              <p className="cart-terms"><a href={_routes.termsPage} target="_blank">{App.t('cart.read_terms')}</a></p>

              <div className="input-buttons">
                <button className={`btn -green ${false ? '-isLoading' : ''}`}>{App.t('cart.complete_order')}</button>
              </div>
            </form>
          )
        }}
      </Form>
    );
  }

}

Payment.propTypes = {
  createOrder: PropTypes.func.isRequired,
  setStripe: PropTypes.func.isRequired,
  tokenReceived: PropTypes.bool.isRequired,
};

export default Payment;
